(function () {
  function init() {
    var thumbs = document.querySelector('media-gallery > slider-component.thumbnail-slider');
    if (!thumbs) return;
    function update() {
      var over = thumbs.scrollHeight - thumbs.clientHeight > 4;
      var atEnd = thumbs.scrollTop + thumbs.clientHeight >= thumbs.scrollHeight - 4;
      thumbs.classList.toggle('ss-fade', over && !atEnd);
    }
    thumbs.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(update);
      ro.observe(thumbs);
      var list = thumbs.querySelector('.thumbnail-list');
      if (list) ro.observe(list);
    }
    update();
    setTimeout(update, 600);
    setTimeout(update, 1800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
